/*
 * @Description: 相关协议的文本
 * @Author: Harry
 * @Date: 2020-12-28 18:18:08
 * @LastEditTime: 2020-12-29 11:41:45
 * @LastEditors: Harry
 */
import i18n from "@/locales";

export default [
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("@/views/protocols/PrivacyPolicy.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("policy.pageTitle")
    }
  },
  {
    path: "/customer-agreement",
    name: "customer-agreement",
    component: () => import("@/views/protocols/CustomerAgreement.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("protocols.customer_agreement_nav_title")
    }
  },
  {
    path: "/license-agreement",
    name: "license-agreement",
    component: () => import("@/views/protocols/LicenseAgreement.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("protocols.license_agreement_nav_title")
    }
  },
  {
    path: "/register-privacy-policy",
    name: "register-privacy-policy",
    component: () => import("@/views/protocols/RegisterPrivacyPolicy.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("protocols.register_privacy_policy_nav_title")
    }
  },
  {
    path: "/login-disclaimers",
    name: "LoginDisclaimers",
    component: () => import("@/views/protocols/LoginDisclaimers.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("disclaimers.title")
    }
  }
];
